import React from 'react';
import logo from '../../assets/images/favicon.png';

interface FullPageLoaderProps {
    message?: string;
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ message = "Loading Please Wait" }) => {
    return (
        <div className="full-page-loader-wrapper">
            <div className="loader-content">
                <div className="spinner-box">
                    <div className="orbit-ring"></div>
                    <div className="inner-ring"></div>
                    <img src={logo} alt="Logo" className="loader-logo" />
                </div>
                <div className="loading-text-container">
                    <p className="loading-text">{message}</p>
                    <div className="loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FullPageLoader;
